import withShow from "@common/withShow";
import { Button } from "@components/index";
import { useSafeNavigate } from "@routes/hooks/useSafeNavigate";
import type React from "react";

type Props = {
  close: () => void;
};

const HeaderButtonDelayManagement: React.FC<Props> = ({ close }) => {
  const navigate = useSafeNavigate();

  return (
    <Button
      blockedWidth
      size="lg"
      content="start"
      buttonStyle="tertiary"
      icon="warning"
      label="Gestão de Atrasos Timeline"
      onClick={() => {
        close();
        void navigate("/delay-management");
      }}
    />
  );
};

export default withShow(HeaderButtonDelayManagement);
